import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import styles from './NotFoundPage.module.css';

export function NotFoundPage() {
  useDocumentTitle('Page not found');

  return (
    <div className={styles.wrap}>
      <p className="eyebrow">404</p>
      <h1 className={styles.title}>Page not found</h1>
      <p className={styles.body}>
        The page you&rsquo;re looking for doesn&rsquo;t exist.
      </p>
      <Link to="/" className="btn btn-primary">
        Back to Home
      </Link>
    </div>
  );
}
